import axios from 'axios'
import HTTP from './http'

export default {
    getSubscriptions: () => axios.post(HTTP.SUBSCRIPTIONS),
    getAllSubscriptions: () => axios.get(HTTP.SUBSCRIPTIONS),
    handleFreezeSub: (id, active) => axios.post(HTTP.FREEZE_SUB, { id, active }),
    updateSub: item => axios.post(HTTP.UPDATE_SUB, { item }),
    addSub: payload => axios.post(HTTP.ADD_SUB, { payload }),
    canceledSub: payload => axios.post(HTTP.CANCELED_SUB, payload),
    canceledSpecificSub: payload => axios.post(HTTP.CANCELED_SPEC_SUB, payload),
    updateBankApprovalStatus: payload => axios.put(HTTP.UPDATE_BANK_APPROVAL, { ...payload }),
    updateSubscriptionStatus: payload => axios.put(HTTP.UPDATE_SUBSCRIPTION_STATUS, { ...payload }),
    updateBlockedCardSubscriptionStatus: payload =>
        axios.put(HTTP.UPDATE_BLOCKED_CARD_SUBSCRIPTION_STATUS, { ...payload }),
    cancelSpecialSubscription: payload => axios.put(HTTP.CANCEL_SPECIAL_SUB, { ...payload }),
    getFlyMaxExpiration: () => axios.get(HTTP.FLY_EXPIRATION),
    // include_history добавляется только когда оператор попросил "הצג גם שטופלו": на сервере это
    // разбор payload старых сканов, обычный опрос виджета за него платить не должен.
    getStoDuplicatesStatus: (payload?: { include_history?: boolean }) =>
        payload && payload.include_history
            ? axios.get(HTTP.STO_DUPLICATES_STATUS, { params: { include_history: 'true' } })
            : axios.get(HTTP.STO_DUPLICATES_STATUS),
    resolveStoDuplicate: payload => axios.post(HTTP.STO_DUPLICATES_RESOLVE, { ...payload }),
    unresolveStoDuplicate: user_id => axios.delete(`${HTTP.STO_DUPLICATES_RESOLVE}/${user_id}`)
}
